import { Component, Input } from '@angular/core';
import { FEATURES } from '@shared/constants/splitio-features';
import { ProductDetail } from '@usf/product-types';

@Component({
  selector: 'app-product-detail-disclaimer',
  templateUrl: './product-detail-disclaimer.component.html',
  styleUrls: ['./product-detail-disclaimer.component.scss'],
})
export class ProductDetailDisclaimerComponent {
  @Input() product: ProductDetail;

  PFASFeatureFlag = FEATURES.split_global_PFAS_restriction.name;
  constructor() {}
}
